const styles = () => {
  return {
    '.grecaptcha-badge': {
      zIndex: 'toast',
    },
  };
};

export default styles;
